import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  title: {
    color: '#ffae49',
    composes: ['mx24', 'mt0', 'mb12', 'is-bold', 'fs20'],
  },
});

const RideTooltipTitleComponent = ({ title }) => {
  const classes = useStyles();
  return (
    <h2 className={classes.title}>
      <span>{title}</span>
    </h2>
  );
};

RideTooltipTitleComponent.propTypes = {
  title: PropTypes.string.isRequired,
};

export default RideTooltipTitleComponent;
